module.exports = __webpack_public_path__ + "static/media/carouselB.50f328a2.jpg";